import { useCallback, useState } from 'react';

import { selectHasStagedChanges } from '../state/selectors';
import { useAnalyticalDatasetDefinitionStore } from '../state/useAnalyticalDatasetDefinitionStore';
import type { UseAdStagedChangesPillResult } from '../types';

export const useAdStagedChangesPill = (): UseAdStagedChangesPillResult => {
  const hasStagedChanges = useAnalyticalDatasetDefinitionStore(selectHasStagedChanges);

  const [isSaveOpen, setSaveOpen] = useState(false);
  const [isRevertOpen, setRevertOpen] = useState(false);

  const onSaveClick = useCallback(() => setSaveOpen(true), []);
  const onRevertClick = useCallback(() => setRevertOpen(true), []);
  const onCloseSave = useCallback(() => setSaveOpen(false), []);
  const onCloseRevert = useCallback(() => setRevertOpen(false), []);

  return {
    visible: hasStagedChanges,
    isSaveOpen,
    isRevertOpen,
    onSaveClick,
    onRevertClick,
    onCloseSave,
    onCloseRevert,
  };
};
